import type { ApolloError } from '@apollo/client';
import { $ } from '../lib/generated/zeus';
import { useTypedMutation } from '../lib/generated/zeus/apollo';
import { eventData } from '../lib/graphql/common/queries';
import { genericScalars } from '../lib/graphql/helpers';

/**
 * Provides GraphQL mutation to create a Team.
 * @returns custom hook that provides GraphQL mutation to create a Team.
 */
const useCreateTeam = (onError: (e: ApolloError) => void) => {
  const mutation = useTypedMutation(
    {
      insert_event_team_created_one: [
        {
          object: {
            name: $('name', 'String!'),
            team_type: $('teamType', 'String!'),
            internal_order_number: $('internalOrderNumber', 'String'),
            team_settings: $('teamSettings', 'jsonb'),
            team_role_assignments: $(
              'teamRoleAssignments',
              'event_team_role_assignment_created_arr_rel_insert_input!'
            ),
            event: eventData('team_created'),
          },
        },
        {
          team_id: true,
        },
      ],
    },
    {
      scalars: genericScalars,
      apolloOptions: {
        onError,
        // We evict all team related cache after mutation to make sure ..
        // .. the all teams query will fetch again for the latest updates.
        // Reference: https://github.com/apollographql/apollo-client/issues/5419#issuecomment-1242511457
        update: (cache) => {
          cache.evict({ fieldName: 'team' });

          cache.gc();
        },
      },
    }
  );

  return mutation;
};

export default useCreateTeam;
